import React, { useEffect } from 'react';
import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import {
  Information,
  withTranslation,
} from '@piwikpro/ui-components';
import { MarketingCratePaymentsState } from '@piwikpro/marketing-crate/redux';
import { connect, ConnectedProps } from 'react-redux';
import { withInject } from '@piwikpro/platform';
import { BillingService } from '@piwikpro/marketing-crate';
import { TFunction } from 'react-i18next';

const mapStateToProps = (
  state: { session: SessionState } & MarketingCratePaymentsState,
) => ({
  isLoading: state.payments.tiers.isLoading
      || state.payments.subscription.isLoading,
  failed: state.payments.tiers.failed,
  userLanguage: state.session.language,
  tiers: state.payments.tiers.details,
  subscription: state.payments.subscription,
});

const connector = connect(mapStateToProps);

type ReduxProps = ConnectedProps<typeof connector>;

interface InjectedProps {
  billingService: BillingService
  i18n: import('i18next').i18n
  t: TFunction
}

interface Props extends ReduxProps, InjectedProps {}

const ScheduledActionInformation: React.FunctionComponent<Props> = ({
  billingService, tiers, t, failed, isLoading, subscription, userLanguage, i18n,
}) => {
  if (failed || isLoading) return null;

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!tiers) {
          await billingService.getTiers();
        }
        // eslint-disable-next-line no-empty
      } catch {}
    };

    fetchData();
  }, []);

  if (subscription.details?.scheduled_change_action === 'cancel') {
    return <Information type="warning">{t('marketing.scheduled-action-information.core.info')}</Information>;
  }

  const traffic = tiers?.find(({ id }) => id === subscription.details?.requested_price_id)?.traffic;

  const translatedPeriod = t(
    subscription.details?.billing_cycle === 'year'
      ? 'marketing.scheduled-action-information.period.yearly'
      : 'marketing.scheduled-action-information.period.monthly',
  );

  return (
    <Information type="warning">
      {t('marketing.scheduled-action-information.downgrade.info', {
        actionsPerMonth: i18n.format(Number(traffic), '', userLanguage),
        billingPeriod: translatedPeriod,
      })}
    </Information>
  );
};

export default connector(withInject<InjectedProps>({
  billingService: 'MarketingCrate.billingService',
})(
  withTranslation('administration')(ScheduledActionInformation as any),
));
